import Handlebars from "handlebars/runtime";
import toastr from "toastr";
import VueI18n from "@Shared/@i18n";
import { TOASTR_OPTIONS } from "../../shared/utils/constants";
import jqueryEvents from "@Shared/utils/events";
import jqueryExtra from "@Shared/utils/jquery-extra";
import HandlebarsHelpers from "../../shared/utils/helpers";
import Amplitude from "../../shared/utils/amplitude";
import Vue from "vue";
import store from "./store";
import VueRouter from "./routes/vue-router";
import VueInit from "@Shared/utils/vue";
import { bindGlobalErrorBoundary } from "./routes/error";
import TitleMixin from "@Shared/@Utils/shared-mixins/title-mixin";
import App from "./modules/app";
import { clearDeprecatedStorage } from "@Shared/@Utils/utils";
VueInit();
Amplitude.init("client");
Vue.mixin(TitleMixin("clientPortalDocumentTitle"));
window.idleTime = 0;
(async () => {
  bindGlobalErrorBoundary();
  $(document).ready(async () => {
    //clear old sammy store
    clearDeprecatedStorage();
    toastr.options = TOASTR_OPTIONS;
    HandlebarsHelpers.register(Handlebars);
    jqueryEvents.init();
    jqueryExtra.init(window.$);
    new Vue({
      i18n: VueI18n,
      router: VueRouter,
      store,
      render: h => h(App)
    }).$mount("#body");
  });
})();